import { FetchRequest } from "@/helpers/fetch-request"
import {
    applyIncomingFieldRenames,
    fieldReferencePayload,
    revertIncomingFieldRenames
} from "@/helpers/relationship-references"

export class RelationshipReferenceService {
    constructor(tab) {
        this.tab = tab
    }

    apply(tableName, renames) {
        return applyIncomingFieldRenames(
            this.tab?.schema?.schema_data?.tables,
            tableName,
            renames
        )
    }

    revert(changes) {
        revertIncomingFieldRenames(changes)
    }

    async save(changes) {
        const fields = fieldReferencePayload(changes)
        if (!fields.length || !this.tab?.schema?.slug) return

        const request = new FetchRequest(`schemas/${this.tab.schema.slug}/update_multiple_fields`, 'POST')
        request.config.body = JSON.stringify({ fields })
        return request.send().catch(() => {
            this.tab.unsaved = true
        })
    }
}
